import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const OverrideIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_10712_55692)">
            <path
               d="M15.8581 0C15.1456 0 14.5725 0.573214 14.5725 1.28571C14.5725 1.99821 15.1456 2.57143 15.8581 2.57143H19.613L0.377636 21.8036C-0.125879 22.3071 -0.125879 23.1214 0.377636 23.6196C0.881152 24.1179 1.69535 24.1232 2.19351 23.6196L21.4235 4.3875V8.14286C21.4235 8.85536 21.9967 9.42857 22.7091 9.42857C23.4215 9.42857 23.9946 8.85536 23.9946 8.14286V1.28571C23.9946 0.573214 23.4215 0 22.7091 0L15.8581 0ZM2.19886 0.375C1.69535 -0.123214 0.881152 -0.123214 0.377636 0.375C-0.125879 0.873214 -0.120522 1.69286 0.377636 2.19643L8.96953 10.7893L10.7854 8.97321L2.19886 0.375ZM13.2119 15.0321L19.613 21.4286H15.8581C15.1456 21.4286 14.5725 22.0018 14.5725 22.7143C14.5725 23.4268 15.1456 24 15.8581 24H22.7144C23.4268 24 24 23.4268 24 22.7143V15.8571C24 15.1446 23.4268 14.5714 22.7144 14.5714C22.002 14.5714 21.4289 15.1446 21.4289 15.8571V19.6125L15.0331 13.2107L13.2173 15.0268L13.2119 15.0321Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10712_55692">
               <rect
                  width="24"
                  height="24"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default OverrideIcon
